var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"van-nav-tb"},[_c('van-nav-bar',{attrs:{"title":"培训通知","left-text":"","left-arrow":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}})],1),_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.detailData.title))]),_c('p',[_vm._v(_vm._s(_vm.detailData.content))])]),_c('GbFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }